import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {AdsService} from '../../../service/ads.service';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {InformType} from '../../../../global/util/enum/InformType';
import {Dialog} from '../../../../global/util/Dialog';
import {Constant} from '../../../../global/util/Constant';

@Component({
  selector: 'app-add-edit-notice',
  templateUrl: './add-edit-ads.component.html',
  styleUrls: ['./add-edit-ads.component.css']
})
export class AddEditAdsComponent implements OnInit {
  title = 'TITLE.VIEW-ADS';
  adsForm: FormGroup;
  ads: any;
  adsTypes = LocalStorage.getAdsType();
  loading: any;
  adsType: number;
  progressUpdate: any;

  constructor(public activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private noticeService: AdsService) {
    this.createForm();
  }

  ngOnInit(): void {
    if (this.isNewAds) {
      this.adsType = this.adsTypes[0].id;
    } else {
      this.adsType = this.ads.type;
    }
    this.addRow();
  }

  cancel() {
    this.activeModal.close();
  }

  save() {
    if (this.isNewAds) {
      this.register();
    } else {
      this.edit();
    }
  }

  register() {
    if (this.adsForm.invalid) {
      this.adsForm.markAllAsTouched();
      return;
    }
    const formData = new FormData();
    formData.append('type', String(this.adsType));
    formData.append('description', this.ads.description ? this.ads.description : '-');
    formData.append('link', this.ads.link ? this.ads.link : null);
    for (const doc of this.arrayImage.controls) {
      formData.append('imgFile', doc.value.file);
    }
    this.noticeService.save(formData).subscribe((event: HttpEvent<any>) => {
      this.loading = true;
      switch (event.type) {
        case HttpEventType.Sent:
          // TODO When request has been made
          break;
        case HttpEventType.ResponseHeader:
          // TODO When response header has been received
          break;
        case HttpEventType.UploadProgress:
          this.progressUpdate = Math.round(event.loaded / event.total * 100);
          break;
        case HttpEventType.Response:
          this.loading = false;
          this.activeModal.close(InformType.Success);
          break;
      }
    }, error => {
      this.loading = false;
      this.progressUpdate = 0;
      Dialog.show(InformType.Danger, this.title);
    });
  }

  private createForm() {
    this.adsForm = this.formBuilder.group({
      type: [],
      description: [],
      link: [],
      arrayImage: this.formBuilder.array([]),
      showAds: []
    });
  }

  changeStatus(event: any, index: number) {
    const group = this.arrayImage.at(index);
    const selectedFile = (event.target as HTMLInputElement).files[0];
    group.patchValue({
      file: selectedFile,
      filename: selectedFile.name
    });
    group.get('file').updateValueAndValidity();
  }


  addRow() {
    const imageForm = this.formBuilder.group({
      file: [null, [Validators.required]],
      filename: ['']
    });
    this.arrayImage.push(imageForm);
  }

  private edit() {
    this.ads.type = this.adsType;
    const formData = new FormData();
    formData.append('adId', this.ads.id);
    formData.append('type', this.ads.type);
    formData.append('description', this.ads.description);
    formData.append('link', this.ads.link);
    formData.append('showAds', this.ads.showAds);
    for (const doc of this.arrayImage.controls) {
      formData.append('imgFile', doc.value.file);
    }
    this.noticeService.update(formData).subscribe((event: HttpEvent<any>) => {
      this.loading = true;
      switch (event.type) {
        case HttpEventType.Sent:
          // TODO When request has been made
          break;
        case HttpEventType.ResponseHeader:
          // TODO When response header has been received
          break;
        case HttpEventType.UploadProgress:
          this.progressUpdate = Math.round(event.loaded / event.total * 100);
          break;
        case HttpEventType.Response:
          this.loading = false;
          this.activeModal.close(InformType.Success);
          break;
      }
    }, error => {
      this.loading = false;
      this.progressUpdate = 0;
      Dialog.show(InformType.Danger, this.title);
    });
  }

  change(adType: number) {
    switch (adType) {
      case Constant.TEXT:
        this.arrayImage.controls[0].get('file').clearValidators();
        this.arrayImage.reset();
        break;
      default:
        this.arrayImage.controls[0].get('file').setValidators(Validators.required);
    }
    this.arrayImage.controls[0].get('file').updateValueAndValidity();
  }

  isInvalidControl(ctrlName: string, index) {
    return this.arrayImage.controls[index].get(ctrlName).invalid
      && this.arrayImage.controls[index].get(ctrlName).touched;
  }

  isTextType(adsType: number) {
    return Constant.TEXT === adsType;
  }

  deleteRow(index: number) {
    this.arrayImage.removeAt(index);
  }

  get isNewAds() {
    return undefined === this.ads.id;
  }

  get isImageType() {
    return this.adsType === 1;
  }

  get arrayImage() {
    return this.adsForm.get('arrayImage') as FormArray;
  }

  get isActive(){
    return String(this.ads.showAds) === 'true';
  }
}
